import * as s from "../../LoginStyled";
import Input from "components/atoms/input/Input";
import { ValidateWord } from "components/atoms/text/Text";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import { LoginInfo } from "../../LoginContainer";
import { KeyboardEvent } from "react";
import BigButton from "components/atoms/buttons/BigButton";

interface Props {
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeLoginInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleClick?: () => void;
  disabled?: boolean;
}
export default function InputEmailForm({
  loginInfo,
  isValidated,
  validateMsg,
  onChangeLoginInfo,
  handleClick,
  disabled,
}: Props) {
  return (
    <s.InputWrapper className="input-email-form">
      <Input
        id="dw_login_input_email"
        type="new-email"
        name="email"
        value={loginInfo.email}
        disabled={disabled}
        placeholder="Please enter an email"
        onChange={onChangeLoginInfo}
        onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            handleClick?.();
          }
        }}
        autoComplete="false"
        autoFocus
        isValidated={isValidated.email}
        style={{ marginBottom: handleClick ? 0 : -5 }}
        data-testid="auth-signin-email-input-email-change-login-info"
      />

      {validateMsg.email && (
        <s.ValidateWrapper>
          <ValidateWord data-testid="auth-signin-email-validate-email">
            {validateMsg.email}
          </ValidateWord>
        </s.ValidateWrapper>
      )}

      {handleClick && (
        <BigButton
          label="Next"
          onClickBtn={() => handleClick?.()}
          data-testid="auth-signin-email-button-click"
        />
      )}
    </s.InputWrapper>
  );
}
